import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Subtract2 from "../assets/images/home/Subtract2.png";
import Union from "../assets/images/home/Union.png";
import ClientLogo1 from "../assets/images/home/client-logo1.png";
import ClientLogo10 from "../assets/images/home/client-logo10.png";
import ClientLogo2 from "../assets/images/home/client-logo2.png";
import ClientLogo3 from "../assets/images/home/client-logo3.png";
import ClientLogo4 from "../assets/images/home/client-logo4.png";
import ClientLogo5 from "../assets/images/home/client-logo5.png";
import ClientLogo6 from "../assets/images/home/client-logo6.png";
import ClientLogo7 from "../assets/images/home/client-logo7.png";
import ClientLogo8 from "../assets/images/home/client-logo8.png";
import ClientLogo9 from "../assets/images/home/client-logo9.png";
import ClientsImg1 from "../assets/images/home/clients-img1.jpg";
import ClientsImg2 from "../assets/images/home/clients-img2.jpg";
import ClientsImg3 from "../assets/images/home/clients-img3.jpg";
import ClientsImg4 from "../assets/images/home/clients-img4.jpg";
import Flower from "../assets/images/home/flower.png";
import WomanImg1 from "../assets/images/home/woman-img1.png";
import WomanImg2 from "../assets/images/home/woman-img2.png";
import WomanImg3 from "../assets/images/home/woman-img3.png";
import WomanImg4 from "../assets/images/home/woman-img4.png";
import WorkingProcessWoman from "../assets/images/home/working-process-woman.png";
import WebCopywriter1 from "../assets/images/svg/WebCopywriter1.svg";
import WebCopywriter2 from "../assets/images/svg/WebCopywriter2.svg";
import WebCopywriter3 from "../assets/images/svg/WebCopywriter3.svg";
import WebCopywriter4 from "../assets/images/svg/WebCopywriter4.svg";
import WebCopywriter5 from "../assets/images/svg/WebCopywriter5.svg";
import WebCopywriter6 from "../assets/images/svg/WebCopywriter6.svg";
import WebCopywriter7 from "../assets/images/svg/WebCopywriter7.svg";
import WebCopywriter8 from "../assets/images/svg/WebCopywriter8.svg";
import MoreServicesBtn from "../assets/images/svg/more-services-btn.svg";
import SellsIcon1 from "../assets/images/svg/sells-icon1.svg";
import SellsIcon2 from "../assets/images/svg/sells-icon2.svg";
import SellsIcon3 from "../assets/images/svg/sells-icon3.svg";
import SeoServicesSvg1 from "../assets/images/svg/seo-services-svg1.svg";
import SeoServicesSvg2 from "../assets/images/svg/seo-services-svg2.svg";
import SeoServicesSvg3 from "../assets/images/svg/seo-services-svg3.svg";
import SeoServicesSvg4 from "../assets/images/svg/seo-services-svg4.svg";
import WorkingProcessSvg1 from "../assets/images/svg/working-process-svg1.svg";
import WorkingProcessSvg2 from "../assets/images/svg/working-process-svg2.svg";
import WorkingProcessSvg3 from "../assets/images/svg/working-process-svg3.svg";
import HomeVideo from "../assets/video/video.mp4";
import ClientsSaySlider from '../component/ClientsSaySlider';
import FixHeader from '../component/FixHeader';
import Footer from '../component/Footer';
import LatestBlog from '../component/LatestBlog';
import Loader from '../component/Loader';

import MediaImg1 from "../assets/images/home/prova1.jpeg"; // Jornal do Recife
import MediaImg2 from "../assets/images/home/prova2.jpeg"; // Revista Atual
import MediaImg3 from "../assets/images/home/sobremim.jpeg"; // Citação/Perfil

import LogoTitle from "../assets/images/home/unifatecie-logo.webp"; // logo


const Home = () => {
    const navigate = useNavigate()
    // Infinite Marquee
    useEffect(() => {
        const logosContainers = document.querySelectorAll(".logos");

        logosContainers.forEach((logosContainer) => {
            const slide = logosContainer.querySelector(".logos-slide");
            if (slide) {
                const copy = slide.cloneNode(true);
                logosContainer.appendChild(copy);
            }
        });
    }, []);
    
    const scrollToSection = (id) => {
    const el = document.getElementById(id);
    if (el) {
        el.scrollIntoView({ behavior: "smooth" });
    }
};


    // Increment Decrement
    const [number1, setNumber1] = useState(100);
    const [number2, setNumber2] = useState(10);

    const incrementValue1 = 100;
    const decrementValue1 = 100;
    const incrementValue2 = 10;
    const decrementValue2 = 10;

    const updateTotal = () => {
        return number1 * number2;
    };

    const handleIncrement1 = () => {
        setNumber1((prev) => prev + incrementValue1);
    };

    const handleDecrement1 = () => {
        setNumber1((prev) => (prev - decrementValue1 < 0 ? 0 : prev - decrementValue1));
    };

    const handleIncrement2 = () => {
        setNumber2((prev) => prev + incrementValue2);
    };

    const handleDecrement2 = () => {
        setNumber2((prev) => (prev - decrementValue2 < 0 ? 0 : prev - decrementValue2));
    };

    return (

        <div className="site_contain" id="sobre">
            <Loader />
            <FixHeader />
            {/* <!-- ====================================== Section-one ===================================== --> */}
            <section>
                <div className="container overflow-hidden">
                    <div className="row section-one-row">
                        <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-12 ">
                                                    <img data-aos="fade-right" className="woman-img1" src={WomanImg1} alt="woman-img1" />
                                                </div>
                        <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-12 section-one-col">
                            <div>
                                <div className="welcome-header">
                                    <div className="welcome-main" data-aos="fade-left">
                                        <p className="welcome"><span className="wave">👋</span> Bem-vindo !!</p>
                                    </div>
                                </div>
                                <h1 className="emily" data-aos="fade-left">Sou Philippe Sassi</h1>
                                <h2 className="FreelanceCopyright" data-aos="fade-left">Empresário Investidor</h2>
                                <div className="text-img-section-main-grid">
                                    <div data-aos="fade-up">
                                        <p className="Since">
                                            Atuo nos segmentos de Educação, Turismo e Imóveis, conectando gestão estratégica,
                                            desenvolvimento de pessoas e visão financeira para construir negócios sustentáveis.
                                        </p>
                                        <div className="hire-me-btn-main">
                                            <div className="button button1" data-text="Whatsapp" onClick={() =>
                                                window.open('https://wa.me/552731910677', '_blank')}>
                                                <span>Whatsapp</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="video-container">
    <video
        autoPlay
        muted
        loop
        playsInline
        className="services-page-video"
        poster={WomanImg1} // pode usar uma imagem estática de fallback
    >
        <source src={HomeVideo} type="video/mp4" />
        {/* Fallback caso o navegador não suporte o vídeo */}
        Desculpe, seu navegador não suporta vídeo HTML5.
    </video>
    <img src={Subtract2} alt="" className="Subtract" />
</div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="logos">
                    <div className="logos-slide">
                        <div className="marquee__content">
                            <div className="marquee-img-main">
                                <p>educação</p>
                                <img className="marquue-flower" src={Flower} alt="educação" />
                            </div>
                            <div className="marquee-img-main">
                                <p>turismo</p>
                                <img className="marquue-flower" src={Flower} alt="turismo" />
                            </div>
                            <div className="marquee-img-main">
                                <p>imóveis</p>
                                <img className="marquue-flower" src={Flower} alt="imóveis" />
                            </div>
                            <div className="marquee-img-main">
                                <p>consultoria</p>
                                <img className="marquue-flower" src={Flower} alt="consultoria" />
                            </div>
                            <div className="marquee-img-main">
                                <p>liderança</p>
                                <img className="marquue-flower" src={Flower} alt="liderança" />
                            </div>
                            <div className="marquee-img-main">
                                <p>planejamento</p>
                                <img className="marquue-flower" src={Flower} alt="planejamento" />
                            </div>
                            <div className="marquee-img-main">
                                <p>franquias</p>
                                <img className="marquue-flower" src={Flower} alt="franquias" />
                            </div>
                            <div className="marquee-img-main">
                                <p>propósito</p>
                                <img className="marquue-flower" src={Flower} alt="propósito" />
                            </div>
                            <div className="marquee-img-main">
                                <p>estratégia</p>
                                <img className="marquue-flower" src={Flower} alt="estratégia" />
                            </div>
                            <div className="marquee-img-main">
                                <p>resultados</p>
                                <img className="marquue-flower" src={Flower} alt="resultados" />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* <!-- ====================================== Section Two ===================================== --> */}
            <section>
                <div className="container">
                    <div className="row">
                        <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-12 position-relative">
                            <div className="secton-two-col-bg-position">
                                <div className="secton-two-col-bg">
                                    <h2 className="section-heading-text" data-aos="fade-up">
                                        <span>Minha <br /> </span>  atuação
                                    </h2>
                                    <p className="section-sub-text libero" data-aos="fade-up">
                                        Minha trajetória une gestão financeira, administração pública e liderança de times
                                        em grandes operações educacionais, sempre com foco em performance, inovação e visão de longo prazo.
                                    </p>
                                </div>
                                <div className="project-done-main-group">
                                    <h3 className="projectdone">+ de 150 projetos e parcerias</h3>
                                    <img data-aos="fade-right" className="woman-img1" src={WomanImg2} alt="woman-img1" />
                                </div>
                                <div className="secton-two-col-bg secton-two-col-bg2">
                                    <p className="more-service-text" data-aos="fade-right">
    Conheça mais detalhes!
    <span
        onClick={() => window.open(WomanImg4, "_blank")}
    >
        {" "}
        Clique aqui
    </span>
</p>

                                </div>
                            </div>
                        </div>
                        <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-12 services-list-col-main">
                            <div className="home-page-services-header" data-aos="fade-up">
                                <div className="home-page-services-main">
                                    <img src={SeoServicesSvg1} alt="experiência executiva" />
                                    <div>
                                        <p className="content-text">visão estratégica aplicada</p>
                                        <h3 className="seo-optimized">Experiência em alta gestão</h3>
                                    </div>
                                </div>
                                <p className="non">
                                    Anos liderando operações em educação, turismo e imóveis, com decisões pautadas em dados,
                                    governança e resultados consistentes.
                                </p>
                            </div>
                            <div className="home-page-services-header" data-aos="fade-up">
                                <div className="home-page-services-main">
                                    <img src={SeoServicesSvg2} alt="foco em pessoas" />
                                    <div>
                                        <p className="content-text">desenvolvimento humano</p>
                                        <h3 className="seo-optimized">Formação de líderes</h3>
                                    </div>
                                </div>
                                <p className="non">
                                    Atuação direta na formação de novos profissionais e gestores, unindo técnica,
                                    comportamento e propósito.
                                </p>
                            </div>
                            <div className="home-page-services-header" data-aos="fade-up">
                                <div className="home-page-services-main">
                                    <img src={SeoServicesSvg3} alt="parcerias estratégicas" />
                                    <div>
                                        <p className="content-text">redes no Brasil e exterior</p>
                                        <h3 className="seo-optimized">Conexões certas</h3>
                                    </div>
                                </div>
                                <p className="non">
                                    Atuação com parceiros nacionais e internacionais para acelerar expansão,
                                    franquias e novos negócios.
                                </p>
                            </div>
                            <div className="home-page-services-header m-0" data-aos="fade-up">
                                <div className="home-page-services-main">
                                    <img src={SeoServicesSvg4} alt="acompanhamento contínuo" />
                                    <div>
                                        <p className="content-text">foco em execução</p>
                                        <h3 className="seo-optimized">Mentoria próxima</h3>
                                    </div>
                                </div>
                                <p className="non">
                                    Acompanhamento direto das lideranças, com ajustes constantes de rota para garantir
                                    consistência entre estratégia e operação.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* <!-- ====================================== Section Three ===================================== --> */}
            <section className="section-three">
                <div className="container">
                    <h2 className="section-heading-text clients-work" data-aos="fade-up">
                        Negócios que já <span>impactei</span>
                    </h2>
                    <div className="clients-logos">
                        <div className="client-logos-main" data-aos="fade-down">
                            <div className="client-style">
                                <div className="client-wrapper client-with-hover-img">
                                    <div className="client-hover-img">
                                        <img src={ClientLogo1} alt="Instituições de Ensino" />
                                    </div>
                                    <div className="featured-wrapper">
                                        <img src={ClientLogo1} alt="Instituições de Ensino" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="client-logos-main" data-aos="fade-down">
                            <div className="client-style">
                                <div className="client-wrapper client-with-hover-img">
                                    <div className="client-hover-img">
                                        <img src={ClientLogo2} alt="Empresas de Turismo" />
                                    </div>
                                    <div className="featured-wrapper">
                                        <img src={ClientLogo2} alt="Empresas de Turismo" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="client-logos-main" data-aos="fade-down">
                            <div className="client-style">
                                <div className="client-wrapper client-with-hover-img">
                                    <div className="client-hover-img">
                                        <img src={ClientLogo3} alt="Negócios Imobiliários" />
                                    </div>
                                    <div className="featured-wrapper">
                                        <img src={ClientLogo3} alt="Negócios Imobiliários" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="client-logos-main" data-aos="fade-down">
                            <div className="client-style">
                                <div className="client-wrapper client-with-hover-img">
                                    <div className="client-hover-img">
                                        <img src={ClientLogo4} alt="Franquias e redes" />
                                    </div>
                                    <div className="featured-wrapper">
                                        <img src={ClientLogo4} alt="Franquias e redes" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="client-logos-main" data-aos="fade-down">
                            <div className="client-style">
                                <div className="client-wrapper client-with-hover-img">
                                    <div className="client-hover-img">
                                        <img src={ClientLogo5} alt="Instituições parceiras" />
                                    </div>
                                    <div className="featured-wrapper">
                                        <img src={ClientLogo5} alt="Instituições parceiras" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="client-logos-main" data-aos="fade-down">
                            <div className="client-style">
                                <div className="client-wrapper client-with-hover-img">
                                    <div className="client-hover-img">
                                        <img src={ClientLogo6} alt="Organizações educacionais" />
                                    </div>
                                    <div className="featured-wrapper">
                                        <img src={ClientLogo6} alt="Organizações educacionais" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="client-logos-main" data-aos="fade-down">
                            <div className="client-style">
                                <div className="client-wrapper client-with-hover-img">
                                    <div className="client-hover-img">
                                        <img src={ClientLogo7} alt="Projetos especiais" />
                                    </div>
                                    <div className="featured-wrapper">
                                        <img src={ClientLogo7} alt="Projetos especiais" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="client-logos-main" data-aos="fade-down">
                            <div className="client-style">
                                <div className="client-wrapper client-with-hover-img">
                                    <div className="client-hover-img">
                                        <img src={ClientLogo8} alt="Eventos e palestras" />
                                    </div>
                                    <div className="featured-wrapper">
                                        <img src={ClientLogo8} alt="Eventos e palestras" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="client-logos-main" data-aos="fade-down">
                            <div className="client-style">
                                <div className="client-wrapper client-with-hover-img">
                                    <div className="client-hover-img">
                                        <img src={ClientLogo9} alt="Parceiros internacionais" />
                                    </div>
                                    <div className="featured-wrapper">
                                        <img src={ClientLogo9} alt="Parceiros internacionais" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="client-logos-main" data-aos="fade-down">
                            <div className="client-style">
                                <div className="client-wrapper client-with-hover-img">
                                    <div className="client-hover-img">
                                        <img src={ClientLogo10} alt="Grupo Sassi" />
                                    </div>
                                    <div className="featured-wrapper">
                                        <img src={ClientLogo10} alt="Grupo Sassi" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* <!-- ====================================== Section Four ===================================== --> */}
            <section className="section-four">
                <div className="container">
                    <div className="audience-documet-main">
                        <div>
                            <h2 className="section-heading-text audience" data-aos="fade-down">
                                <span>Liderança que inspira</span> e transforma resultados.
                            </h2>
                            <p className="section-sub-text passages" data-aos="fade-down">
                                Estratégia, gestão financeira e foco em pessoas caminham juntos para que sua empresa
                                cresça com solidez, propósito e visão de futuro.
                            </p>
                        </div>
                        <div>
                            <div data-aos="fade-down">
                                <div className="button button6" data-text="WhatsApp" onClick={() =>
                                    window.open('https://wa.me/552731910677', '_blank')}>
                                    <span>Whatsapp </span>
                                </div>
                            </div>
                            <div data-aos="fade-down">
                                <div className="button button6" data-text="Ver apresentação" onClick={() =>
            window.open(`${process.env.PUBLIC_URL}/biografia.pdf`, "_blank")
        }
>
                                    <span>Ver apresentação</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* <!-- ====================================== Section Five ===================================== --> */}
            <section className="section-five" id="servicos">
                <div className="container position-relative">
                    <div className="section-five-header-srvices" data-aos="fade-down">
                        <h2 className="section-heading-text our-servicestext-main" data-aos="fade-down">
                            Minhas<span> frentes</span> de atuação
                        </h2>
                        <p className="section-sub-text pharetra" data-aos="fade-down">
                            Atendo empresas, gestores e investidores que buscam clareza estratégica, organização financeira
                            e expansão estruturada de seus negócios.
                        </p>
                    </div>
                    <div className="row section-five-row">
                        <div className="col-xxl-3 col-xl-3 col-lg-4 col-md-6" data-aos="fade-up">
                            <div className="contentWriter-Services-box">
                                <img className="WebCopywriter-svg" src={WebCopywriter1} alt="Mentoria em gestão financeira" />
                                <h3 onClick={() => navigate("/")}>Mentoria em Gestão Financeira</h3>
                                <p>
                                    Mentoria focada em controle financeiro pessoal, de diretores e executivos.
                                </p>
                                <div className="services-more-btn-main">
                                    <div onClick={() => window.open('https://wa.me/552731910677', '_blank')} className="services-more-btn">
                                        <img src={MoreServicesBtn} alt="ver mais sobre mentoria financeira" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xxl-3 col-xl-3 col-lg-4 col-md-6" data-aos="fade-down">
                            <div className="contentWriter-Services-box">
                                <img className="WebCopywriter-svg" src={WebCopywriter2} alt="Consultoria estratégica" />
                                <h3 onClick={() => navigate("/")}>Consultoria em Gestão Estratégica</h3>
                                <p>
                                    Focada em consultoria estratégica para novos negócios.
                                </p>
                                <div className="services-more-btn-main">
                                    <div onClick={() => window.open('https://wa.me/552731910677', '_blank')} className="services-more-btn">
                                        <img src={MoreServicesBtn} alt="ver mais sobre consultoria estratégica" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/*<div className="col-xxl-3 col-xl-3 col-lg-4 col-md-6" data-aos="fade-up">
                            <div className="contentWriter-Services-box">
                                <img className="WebCopywriter-svg" src={WebCopywriter3} alt="Expansão de franquias" />
                                <h3 onClick={() => navigate("/")}>Expansão e Franquias</h3>
                                <p>
                                    Apoio na modelagem, estruturação e crescimento de redes de franquias em diferentes segmentos.
                                </p>
                                <div className="services-more-btn-main">
                                    <div onClick={() => window.open('https://wa.me/551151995534', '_blank')} className="services-more-btn">
                                        <img src={MoreServicesBtn} alt="ver mais sobre expansão e franquias" />
                                    </div>
                                </div>
                            </div>
                        </div> */}
                        {/*<div className="col-xxl-3 col-xl-3 col-lg-4 col-md-6" data-aos="fade-down">
                            <div className="contentWriter-Services-box">
                                <img className="WebCopywriter-svg" src={WebCopywriter4} alt="Educação e formação" />
                                <h3 onClick={() => navigate("/")}>Projetos em Educação</h3>
                                <p>
                                    Desenvolvimento de ofertas de cursos, polos e operações educacionais presenciais
                                    e semipresenciais.
                                </p>
                                <div className="services-more-btn-main">
                                    <div onClick={() => window.open('https://wa.me/551151995534', '_blank')} className="services-more-btn">
                                        <img src={MoreServicesBtn} alt="ver mais sobre projetos em educação" />
                                    </div>
                                </div>
                            </div>
                        </div> */}
                        <div className="col-xxl-3 col-xl-3 col-lg-4 col-md-6" data-aos="fade-up">
                            <div className="contentWriter-Services-box">
                                <img className="WebCopywriter-svg" src={WebCopywriter5} alt="Intercâmbio e turismo educacional" />
                                <h3 onClick={() => navigate("/")}>Consultoria em abertura de empresas</h3>
                                <p>
                                    Estruturação de programas internacionais e experiências formativas nos Estados Unidos
                                    e em outros destinos.
                                </p>
                                <div className="services-more-btn-main">
                                    <div onClick={() => window.open('https://wa.me/552731910677', '_blank')} className="services-more-btn">
                                        <img src={MoreServicesBtn} alt="ver mais sobre intercâmbio" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/*<div className="col-xxl-3 col-xl-3 col-lg-4 col-md-6" data-aos="fade-down">
                            <div className="contentWriter-Services-box">
                                <img className="WebCopywriter-svg" src={WebCopywriter6} alt="Investimentos imobiliários" />
                                <h3 onClick={() => navigate("/")}>Estratégia em Imóveis</h3>
                                <p>
                                    Atuação em empreendimentos hoteleiros e comerciais, com visão de retorno e valorização
                                    de ativos.
                                </p>
                                <div className="services-more-btn-main">
                                    <div onClick={() => window.open('https://wa.me/551151995534', '_blank')} className="services-more-btn">
                                        <img src={MoreServicesBtn} alt="ver mais sobre imóveis" />
                                    </div>
                                </div>
                            </div>
                        </div> */}
                        <div className="col-xxl-3 col-xl-3 col-lg-4 col-md-6" data-aos="fade-up">
                            <div className="contentWriter-Services-box">
                                <img className="WebCopywriter-svg" src={WebCopywriter7} alt="Palestras e eventos" />
                                <h3 onClick={() => navigate("/")}>Palestras & Eventos</h3>
                                <p>
                                    Palestra motivacional sobre mentalidade e riqueza.
                                </p>
                                <div className="services-more-btn-main">
                                    <div onClick={() => window.open('https://wa.me/552731910677', '_blank')} className="services-more-btn">
                                        <img src={MoreServicesBtn} alt="ver mais sobre palestras" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* <!--
                        <div className="col-xxl-3 col-xl-3 col-lg-4 col-md-6" data-aos="fade-down">
                            <div className="contentWriter-Services-box">
                                <img className="WebCopywriter-svg" src={WebCopywriter8} alt="Mentoria de propósito" />
                                <h3 onClick={() => navigate("/")}>Mentoria A Caminho do Propósito</h3>
                                <p>
                                    Acompanhamento individual ou em grupo para alinhar vida, carreira, fé e negócios,
                                    inspirado no livro do autor.
                                </p>
                                <div className="services-more-btn-main">
                                    <div onClick={() => window.open('https://wa.me/551151995534', '_blank')} className="services-more-btn">
                                        <img src={MoreServicesBtn} alt="ver mais sobre mentoria de propósito" />
                                    </div>
                                </div>
                            </div>
                        </div> -->*/}
                    </div>
                </div>
            </section>
            {/* <!-- ====================================== Section 5.1 ===================================== --> */}
            
            {/* */}
            <section className="section-media" style={{ padding: "80px 0", backgroundColor: "#171B22" }}>
                
                {/* Estilos locais para animação dos cards */}
                <style>
                    {`
                        .media-card-custom {
                            background-color: #FFDB59;
                            padding: 15px;
                            border-radius: 20px;
                            box-shadow: 0 10px 30px rgba(0,0,0,0.5);
                            transition: all 0.3s ease-in-out;
                            cursor: pointer;
                        }
                        .media-card-custom:hover {
                            transform: scale(1.03);
                            background-color: #ffe685;
                            box-shadow: 0 15px 40px rgba(255, 219, 89, 0.2);
                        }
                    `}
                </style>

                <div className="container">
                    {/* CORREÇÃO DO TÍTULO: 
                        Removi a classe 'section-five-header-srvices' que causava o erro no PC.
                        Mantive 'section-heading-text' para pegar a fonte correta do seu CSS.
                    */}
                    <div className="row justify-content-center mb-5">
                        <div className="col-12 text-center" data-aos="fade-down">
                            <h2 className="section-heading-text" style={{ color: "#fff", marginBottom: "15px" }}>
                                Philippe <span style={{ color: "#FFDB59" }}>Na mídia</span>
                            </h2>
                            <p className="section-sub-text pharetra" style={{ color: "#cbd5e1", maxWidth: "700px", margin: "0 auto" }}>
                                Acompanhe a repercussão do nosso trabalho e o reconhecimento da nossa trajetória em grandes veículos de comunicação.
                            </p>
                        </div>
                    </div>

                    {/* GRADE DE IMAGENS */}
                    <div className="row justify-content-center">
                        
                        {/* --- ITEM 1: Reconhecimento --- */}
                        <div className="col-lg-4 col-md-6 mb-5" data-aos="fade-up" data-aos-delay="100">
                            <div className="media-card-custom">
                                <img 
                                    src={MediaImg3} 
                                    alt="Reconhecimento de Gestão" 
                                    className="img-fluid w-100"
                                    style={{ borderRadius: "15px", display: "block", objectFit: "cover", height: "100%" }}
                                />
                            </div>
                            <p className="mt-3 text-center fw-bold" style={{ color: "#fff", letterSpacing: "1px", fontSize: "18px", fontFamily: "Epilogue" }}>
                                Reconhecimento de Gestão e Inovação
                            </p>
                        </div>

                        {/* --- ITEM 2: Jornal --- */}
                        <div className="col-lg-4 col-md-6 mb-5" data-aos="fade-up" data-aos-delay="200">
                            <div className="media-card-custom">
                                <img 
                                    src={MediaImg1} 
                                    alt="Destaque no Jornal" 
                                    className="img-fluid w-100" 
                                    style={{ borderRadius: "15px", display: "block", objectFit: "cover", height: "100%" }}
                                />
                            </div>
                            <p className="mt-3 text-center fw-bold" style={{ color: "#fff", letterSpacing: "1px", fontSize: "18px", fontFamily: "Epilogue" }}>
                                Destaque no Jornal do Recife
                            </p>
                        </div>

                        {/* --- ITEM 3: Revista --- */}
                        <div className="col-lg-4 col-md-6 mb-5" data-aos="fade-up" data-aos-delay="300">
                            <div className="media-card-custom">
                                <img 
                                    src={MediaImg2} 
                                    alt="Capa da Revista" 
                                    className="img-fluid w-100"
                                    style={{ borderRadius: "15px", display: "block", objectFit: "cover", height: "100%" }}
                                />
                            </div>
                            <p className="mt-3 text-center fw-bold" style={{ color: "#fff", letterSpacing: "1px", fontSize: "18px", fontFamily: "Epilogue" }}>
                                Capa da Revista Atual
                            </p>
                        </div>

                    </div>
                </div>
            </section>
            
            {/* <!-- ====================================== Section Six ===================================== --> */}
            <section className="section-six overflow-hidden" id="orderNow">
                <div className="container">
                    <div className="row working-process-row">
                        <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-12">
                            <h2 className="section-heading-text" data-aos="fade-down">
                                Meu <span>processo</span> de trabalho
                            </h2>
                            <p className="section-sub-text facilisi" data-aos="fade-down">
                                Cada projeto começa com escuta ativa, análise de contexto e definição clara de metas,
                                sempre conectado ao propósito do negócio.
                            </p>
                            <div className="working-process-svg-main working-process-svg-main1" data-aos="fade-up">
                                <div><img src={WorkingProcessSvg1} alt="etapa 1" /></div>
                                <div>
                                    <h3 className="seo-optimized get-started">1. Primeiro contato</h3>
                                    <p className="content-text get-started-sub">
                                        Entendemos o momento da empresa, os desafios e onde você quer chegar.
                                    </p>
                                </div>
                            </div>
                            <div className="working-process-svg-main working-process-svg-main-center" data-aos="fade-up">
                                <div>
                                    <img src={WorkingProcessSvg2} alt="etapa 2" />
                                </div>
                                <div>
                                    <h3 className="seo-optimized get-started">2. Diagnóstico & Estratégia</h3>
                                    <p className="content-text get-started-sub">
                                        Mapeamos processos, números e pessoas para construir um plano de ação objetivo.
                                    </p>
                                </div>
                            </div>
                            <div className="working-process-svg-main" data-aos="fade-up">
                                <div>
                                    <img src={WorkingProcessSvg3} alt="etapa 3" />
                                </div>
                                <div>
                                    <h3 className="seo-optimized get-started">3. Implementação & Acompanhamento</h3>
                                    <p className="content-text get-started-sub">
                                        Colocamos a estratégia em prática, acompanhando indicadores e ajustando a rota
                                        junto com a liderança.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-12 section-six-col2 overflow-hidden">
                            <div className="CustomizeOrderBox">
                                <h2 className="section-heading-text customize-order-text">
                                    <span>Planeje</span> seu atendimento
                                </h2>
                                {/* <h3 className="word-count-text">Número de participantes:</h3>
                                <div className="button-increment-decrement-main">
                                    <button id="decrement" onClick={handleDecrement1} className="button-increment-decrement">
                                        <img src={SubstractionSvg} alt="diminuir" />
                                    </button>
                                    <span id="number" className="number">{number1}</span>
                                    <button id="increment" onClick={handleIncrement1} className="button-increment-decrement">
                                        <img src={AdditionSvg} alt="aumentar" />
                                    </button>
                                </div>
                                <h3 className="word-count-text">Quantidade de encontros:</h3>
                                <div className="button-increment-decrement-main">
                                    <button id="decrement2" onClick={handleDecrement2} className="button-increment-decrement">
                                        <img src={SubstractionSvg} alt="diminuir" />
                                    </button>
                                    <span id="number2" className="number">{number2}</span>
                                    <button id="increment2" onClick={handleIncrement2} className="button-increment-decrement">
                                        <img src={AdditionSvg} alt="aumentar" />
                                    </button>
                                </div> */}
                                <h3 className="word-count-text">Seu e-mail:</h3>
                                <div className="button-increment-decrement-main mb-0">
                                    <input type="text" placeholder="Digite seu melhor e-mail" name='EntEmail' />
                                </div>
                            </div>
                            <div className="order-total-box-main">
                                {/* <div>
                                    <p>Estimativa de investimento:</p>
                                    <p className="amount">${updateTotal()}</p>
                                </div> */}
                                <div>
                                    <div className="button" data-text="Solicitar proposta" onClick={() =>
                                                window.open('https://wa.me/552731910677', '_blank')}>
                                        <span>Solicitar proposta</span>
                                    </div>

                                </div>
                            </div>
                            <img className="working-process-woman" src={WorkingProcessWoman} alt="consultoria em andamento" data-aos="fade-left" />
                        </div>
                    </div>
                </div>
            </section>
            {/* <!-- ====================================== Section Seven ===================================== --> */}
            <section className="section-seven">
                <div className="container">
                    <div className="row section-seven-row">
                        <div className="col-xxl-6 col-xl-6 col-lg-12">
                            <div className="woman-img3-main">
                                <img className="woman-img3" src={WomanImg3} alt="Philippe em ação com equipes"
                                    data-aos="fade-up" />
                                <img className="union" src={Union} alt="destaque visual" data-aos="fade-up" />
                                <div className="worked-box">
                                    <p className="worked-more">Mais de 100 líderes e equipes impactados</p>
                                    <div className="client-img-main position-relative">
                                        <img className="client-img client-img1" src={ClientsImg1} alt="clientes 1" />
                                        <img className="client-img client-img2" src={ClientsImg2} alt="clientes 2" />
                                        <img className="client-img client-img3" src={ClientsImg3} alt="clientes 3" />
                                        <img className="client-img client-img4" src={ClientsImg4} alt="clientes 4" />
                                        <p className="worked-more worked-more2"> 100+ clientes</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xxl-6 col-xl-6 col-lg-12">
                            <h2 className="section-heading-text" data-aos="fade-up">
                                Histórias de <span>superação,</span> gestão e propósito.
                            </h2>
                            <p className="section-sub-text arcu" data-aos="fade-up">
                                Minha jornada é marcada por desafios, recomeços e conquistas. Hoje ajudo pessoas e empresas
                                a organizarem suas finanças, fortalecerem a liderança e alinharem negócios ao propósito de vida.
                            </p>
                            <ul className="why-choose-list" data-aos="fade-up">
                                <li>Atuação prática: do planejamento à execução com a equipe.</li>
                                <li>Integração entre finanças, pessoas, processos e estratégia.</li>
                                <li>Conteúdo baseado em experiência real e vivência executiva.</li>
                            </ul>
                            <div className="Sample-content-btn-main" data-aos="fade-up">
                                <div
                                    className="button"
                                    data-text="Adquirir livro"
                                    onClick={() => window.open("https://hotmart.com/pt-br/marketplace/produtos/hagsxd-livro-a-caminho-do-proposito-e9zit/W99224592G", "_blank")}>
                                    <span>Adquirir livro</span>
                                </div>

                            </div>
                            <div className="happyclient-main" data-aos="fade-up">
                                <div className="happyclient-sub">
                                    <img src={SellsIcon1} alt="clientes atendidos" />
                                    <div>
                                        <h3>150+</h3>
                                        <p>CLIENTES</p>
                                    </div>
                                </div>
                                <div className="happyclient-sub">
                                    <img src={SellsIcon2} alt="presença geográfica" />
                                    <div>
                                        <h3>3</h3>
                                        <p>PAÍSES</p>
                                    </div>
                                </div>
                                <div className="happyclient-sub">
                                    <img src={SellsIcon3} alt="satisfação" />
                                    <div>
                                        <h3>98%</h3>
                                        <p>SATISFAÇÃO</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* <!-- ====================================== Section Eight ===================================== --> */}
            {/* <section className="section-eight">
                <div className="container">
                    <h2 className="section-heading-text latestProjects-heading" data-aos="fade-up">
                        Negócios e <span>projetos</span> em destaque
                    </h2>
                    <p className="section-sub-text pharetra urna" data-aos="fade-up">
                        Conheça algumas frentes em que atuo diretamente, conectando educação, turismo,
                        investimentos e desenvolvimento de pessoas.
                    </p>
                </div>
                <div className="swiper-wrapper overflow-hidden">
                    <Swiper
                        className="projectSwiper"
                        spaceBetween={30}
                        loop={true}
                        speed={1600}
                        autoplay={{
                            delay: 3000,
                            disableOnInteraction: false,
                        }}
                        breakpoints={{
                            991: {
                                slidesPerView: 5,
                                spaceBetween: 20,
                            },
                            575: {
                                slidesPerView: 3,
                                spaceBetween: 20,
                            },
                            320: {
                                slidesPerView: 2,
                                spaceBetween: 12,
                                centeredSlides: true,
                            },
                        }}
                        modules={[Autoplay]}
                    >
                        <SwiperSlide>
                            <div className="swiper-slide projectSwiper-slide" onClick={() => navigate("/")}>
                                <div className="pro-img-slider-main cs_card cs_style_1">
                                    <div className="cs_card_thumb overflow-hidden position-relative">
                                        <img src={LatestProjectImg1} alt="FBS America" />
                                        <img src={LatestProjectImg1} alt="FBS America" />
                                    </div>
                                    <h2>FBS America</h2>
                                    <h3>Intercâmbio & Educação Internacional</h3>
                                </div>
                            </div>
                        </SwiperSlide>
                        <SwiperSlide>
                            <div className="swiper-slide projectSwiper-slide" onClick={() => navigate("/")}>
                                <div className="pro-img-slider-main cs_card cs_style_1">
                                    <div className="cs_card_thumb overflow-hidden position-relative">
                                        <img src={LatestProjectImg2} alt="Grupo Sassi Educação" />
                                        <img src={LatestProjectImg2} alt="Grupo Sassi Educação" />
                                    </div>
                                    <h2>Grupo Sassi</h2>
                                    <h3>Graduação & Pós-graduação</h3>
                                </div>
                            </div>
                        </SwiperSlide>
                        <SwiperSlide>
                            <div className="swiper-slide projectSwiper-slide" onClick={() => navigate("/")}>
                                <div className="pro-img-slider-main cs_card cs_style_1">
                                    <div className="cs_card_thumb overflow-hidden position-relative">
                                        <img src={LatestProjectImg3} alt="Investimentos Imobiliários" />
                                        <img src={LatestProjectImg3} alt="Investimentos Imobiliários" />
                                    </div>
                                    <h2>Portfólio Imobiliário</h2>
                                    <h3>Hotéis & Imóveis Comerciais</h3>
                                </div>
                            </div>
                        </SwiperSlide>
                        <SwiperSlide>
                            <div className="swiper-slide projectSwiper-slide" onClick={() => navigate("/")}>
                                <div className="pro-img-slider-main cs_card cs_style_1">
                                    <div className="cs_card_thumb overflow-hidden position-relative">
                                        <img src={LatestProjectImg4} alt="Projetos de liderança" />
                                        <img src={LatestProjectImg4} alt="Projetos de liderança" />
                                    </div>
                                    <h2>Programas de Liderança</h2>
                                    <h3>Formação de Gestores</h3>
                                </div>
                            </div>
                        </SwiperSlide>
                        <SwiperSlide>
                            <div className="swiper-slide projectSwiper-slide" onClick={() => navigate("/")}>
                                <div className="pro-img-slider-main cs_card cs_style_1">
                                    <div className="cs_card_thumb overflow-hidden position-relative">
                                        <img src={LatestProjectImg5} alt="Franquias e expansão" />
                                        <img src={LatestProjectImg5} alt="Franquias e expansão" />
                                    </div>
                                    <h2>Expansão de Franquias</h2>
                                    <h3>Modelagem & Estratégia</h3>
                                </div>
                            </div>
                        </SwiperSlide>
                        <SwiperSlide>
                            <div className="swiper-slide projectSwiper-slide" onClick={() => navigate("/")}>
                                <div className="pro-img-slider-main cs_card cs_style_1">
                                    <div className="cs_card_thumb overflow-hidden position-relative">
                                        <img src={LatestProjectImg6} alt="Consultoria empresarial" />
                                        <img src={LatestProjectImg6} alt="Consultoria empresarial" />
                                    </div>
                                    <h2>Sassi Consultoria</h2>
                                    <h3>Gestão & Planejamento</h3>
                                </div>
                            </div>
                        </SwiperSlide>
                        <SwiperSlide>
                            <div className="swiper-slide projectSwiper-slide" onClick={() => navigate("/")}>
                                <div className="pro-img-slider-main cs_card cs_style_1">
                                    <div className="cs_card_thumb overflow-hidden position-relative">
                                        <img src={LatestProjectImg7} alt="Livro A Caminho do Propósito" />
                                        <img src={LatestProjectImg7} alt="Livro A Caminho do Propósito" />
                                    </div>
                                    <h2>A Caminho do Propósito</h2>
                                    <h3>Livro & Experiência Transformadora</h3>
                                </div>
                            </div>
                        </SwiperSlide>
                    </Swiper>
                </div>
            </section> */}
            {/* <!-- ====================================== Section Nine ===================================== --> */}
            <ClientsSaySlider />
            {/* <!-- ====================================== Section Ten ===================================== --> */}
            <LatestBlog />
            <Footer />
        </div>
    )
}
export default Home
